import './CSS_ke_log/CssForFIVEJS.css'
const AlcoholTouch = ()=> {
    return(
        <p id="pncilwala">एक बार जब आप अपने हाथों को साफ कर लेते हैं, तो आपने उन्हें बोतल पर मौजूद किसी भी कीटाणु से कीटाणुरहित कर दिया होगा। यदि हर कोई सार्वजनिक स्थान जैसे सुपरमार्केट के प्रवेश द्वार पर सैनिटाइज़र का उपयोग करता है, तो सांप्रदायिक वस्तुओं पर कीटाणुओं का जोखिम कम होगा और सभी को सुरक्षित रखने में मदद मिलेगी।</p>

    );
}
export default AlcoholTouch;